import { useState } from "react";
import Header from "../../components/Header";
import "../../styles/client-portal.css";

const ClientPortalPage = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setIsLoading(true);

        try {
            console.log("Login attempt:", { email, password });
            await new Promise(resolve => setTimeout(resolve, 1500));
            setError("Portal access coming soon. Please contact support.");
        } catch (err) {
            setError("An error occurred. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="portal-page">
            <Header />
            
            {/* Left - Image */}
            <div className="portal-image-side">
                <div className="portal-image-overlay"></div>
                <img 
                    src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80" 
                    alt="Modern office workspace"
                    className="portal-bg-image"
                />
                <div className="portal-image-content">
                    <h2>Welcome Back</h2>
                    <p>Access your project dashboard, track progress, and collaborate with our team.</p>
                </div>
            </div>

            {/* Right - Form */}
            <div className="portal-form-side">
                <div className="portal-form-wrapper">
                    <div className="portal-header">
                        <h1>Client Portal</h1>
                        <p>Sign in to continue</p>
                    </div>

                    <form className="portal-form" onSubmit={handleSubmit}>
                        {error && <div className="portal-error">{error}</div>}

                        <div className="portal-field">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                placeholder="you@company.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                autoComplete="email"
                            />
                        </div>

                        <div className="portal-field">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                placeholder="••••••••"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                autoComplete="current-password"
                            />
                        </div>

                        <div className="portal-options">
                            <label className="portal-remember">
                                <input type="checkbox" name="remember" />
                                <span>Remember me</span>
                            </label>
                            <a href="/contact" className="portal-forgot">Forgot password?</a>
                        </div>

                        <button 
                            type="submit" 
                            className={`portal-submit ${isLoading ? 'loading' : ''}`}
                            disabled={isLoading}
                        >
                            {isLoading ? <span className="portal-spinner"></span> : "Sign In"}
                        </button>
                    </form>

                    <p className="portal-alt">
                        Not a client? <a href="/contact">Get in touch</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ClientPortalPage;
